import { Divider } from "@mui/material";
import React from "react";
import styles from "./HorizontalDivider.module.css";

interface HorizontalDividerProps {
	readonly className?: string;
}
export default function HorizontalDivider({ className }: HorizontalDividerProps) {
	return <Divider className={`${styles.horizontalDivider} ${className}`} orientation="horizontal" />;
}
